import * as React from 'react';

export function Loader() {
    return <div className="spinner"></div>
}


// WEBPACK FOOTER //
// ./src/components/Loader.js